import Vue from 'vue'
import Router from 'vue-router'
import store from './../store.js'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Deposit = () => import('@/views/Deposit')
const DocsAPI = () => import('@/views/Doc')

const HistoryDepositData = () => import('@/views/history/deposit/Data')
const HistoryDepositShow = () => import('@/views/history/deposit/Show')
const HistoryTransactionData = () => import('@/views/history/transaction/Data')

const SettingProfile = () => import('@/views/settings/Profile')
const SettingPassword = () => import('@/views/settings/Password')

// // Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const Forget = () => import('@/views/pages/Forget')

Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
      let auth = store.getters.isAuth
      if (!auth) next({ name: 'Login' })
      else next()
  } else {
      next()
  }
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { requiresAuth: true }
        },
        {
          path: 'deposit',
          name: 'Deposit',
          component: Deposit,
          meta: { requiresAuth: true }
        },
        {
          path: 'docs',
          name: 'Dokumentasi API',
          component: DocsAPI,
          meta: { requiresAuth: true }
        },
        {
          path: 'history',
          redirect: '/history/transaction',
          name: 'History',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'deposit',
              name: 'Riwayat Deposit',
              component: HistoryDepositData,
              meta: { requiresAuth: true }
            },
            {
              path: 'deposit/:id',
              name: 'Detail Deposit',
              component: HistoryDepositShow,
              meta: { requiresAuth: true }
            },
            {
              path: 'transaction',
              name: 'Riwayat Transaksi',
              component: HistoryTransactionData,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'settings',
          redirect: '/settings/profile',
          name: 'Setting',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'profile',
              name: 'Profile',
              component: SettingProfile,
              meta: { requiresAuth: true }
            },
            {
              path: 'password',
              name: 'Password',
              component: SettingPassword,
              meta: { requiresAuth: true }
            }
          ]
        },
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'forget',
          name: 'Forget',
          component: Forget
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404
    },
  ]
}

export default router

